'use strict';

const css = require('./Modal-style.scss');
const React = require('react');
const PropTypes = require('prop-types');
const FlexModalWrapper = require('react-modal-wrapper');
require('react-modal-wrapper/dist/main.css');

const Modal = ({children, closeModal, closeOnEsc, closeOnOutsideClick, dataTn, isOpened, modalClass, wrapperClass}) => (
    <FlexModalWrapper closeOnEsc={closeOnEsc} closeOnOutsideClick={closeOnOutsideClick} isOpened={isOpened} onClose={closeModal} className={wrapperClass}>
        <div className={modalClass || css.content}>{React.Children.map(children, (c) => React.cloneElement(c, {closeModal, dataTn}))}</div>
    </FlexModalWrapper>
);

Modal.defaultProps = {
    closeOnEsc: true,
    closeOnOutsideClick: true,
    dataTn: 'default-tag',
    modalClass: ''
};

Modal.propTypes = {
    children: PropTypes.node,
    closeModal: PropTypes.func,
    closeOnEsc: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
    dataTn: PropTypes.string,
    isOpened: PropTypes.bool,
    modalClass: PropTypes.string,
    wrapperClass: PropTypes.string
};

module.exports = Modal;



// WEBPACK FOOTER //
// ./assets/js/global/views/modal/Modal.jsx